import { classNames } from "../utils/formatters";
import { useState } from "react";
import {
  FacebookIcon,
  // FacebookMessengerIcon,
  // FacebookMessengerShareButton,
  FacebookShareButton,
  // LinkedinIcon,
  // LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CheckIcon, LinkIcon } from "@heroicons/react/24/solid";
import { User } from "../graphql/generated/graphql";
import { useSession } from "next-auth/react";
import { isInactive, isUnauthorized } from "../utils/connect";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";

const buttonClassName = "hover:scale-110 transition-all shadow-sm rounded-full";

export default function ShareSection({
  shareUrl,
  originalSeller,
}: {
  shareUrl: string;
  originalSeller: User;
}) {
  const { data: session, status: sessionStatus } = useSession();
  const [copied, setCopied] = useState(false);

  const isOriginalSellerFromConnect =
    !isInactive(originalSeller) && !isUnauthorized(originalSeller);
  const isCurrentUserFromConnect =
    sessionStatus === "authenticated" &&
    !isInactive(session?.user) &&
    !isUnauthorized(session?.user);

  const shareUrlWithReferrer =
    isOriginalSellerFromConnect &&
    isCurrentUserFromConnect &&
    originalSeller.username !== session?.user?.username
      ? `${shareUrl}?connect-ref=${session?.user?.username}`
      : shareUrl;

  const isConnect = isCurrentUserFromConnect && isOriginalSellerFromConnect;

  return (
    <div className="mt-2">
      {isConnect && (
        <div className="mt-2 flex rounded-md shadow-sm">
          <div className="relative flex flex-grow items-stretch focus-within:z-10">
            <input
              type="email"
              name="email"
              id="email"
              className="block w-full rounded-none rounded-l-md border-0 py-1.5 text-gray-700 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-500 text-input sm:leading-6"
              value={shareUrlWithReferrer}
              contentEditable={false}
            />
          </div>
          <CopyToClipboard
            text={shareUrlWithReferrer}
            onCopy={() => setCopied(true)}
            className="relative -ml-px inline-flex items-center gap-x-1.5 rounded-r-md px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 bg-gray-50 hover:bg-gray-100 cursor-pointer"
          >
            <span>
              {copied ? (
                <CheckIcon
                  className="-ml-0.5 h-4 w-4 text-green-600"
                  aria-hidden="true"
                />
              ) : (
                <DocumentDuplicateIcon
                  className="-ml-0.5 h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              )}
            </span>
          </CopyToClipboard>
        </div>
      )}
      <div className="flex space-x-2 items-center mt-2 justify-center sm:justify-start">
        <WhatsappShareButton url={shareUrlWithReferrer}>
          <WhatsappIcon size={32} round className={buttonClassName} />
        </WhatsappShareButton>
        <FacebookShareButton url={shareUrlWithReferrer}>
          <FacebookIcon size={32} round className={buttonClassName} />
        </FacebookShareButton>
        {/* <FacebookMessengerShareButton
          url={shareUrlWithReferrer}
          appId={process.env.NEXT_PUBLIC_FACEBOOK_APP_ID}
        >
          <FacebookMessengerIcon size={32} round className={buttonClassName} />
        </FacebookMessengerShareButton> */}
        <TwitterShareButton url={shareUrlWithReferrer}>
          <TwitterIcon size={32} round className={buttonClassName} />
        </TwitterShareButton>
        <TelegramShareButton url={shareUrlWithReferrer}>
          <TelegramIcon size={32} round className={buttonClassName} />
        </TelegramShareButton>
        {/* <LinkedinShareButton url={shareUrlWithReferrer}>
          <LinkedinIcon size={32} round className={buttonClassName} />
        </LinkedinShareButton> */}

        {!isConnect && (
          <CopyToClipboard
            text={shareUrlWithReferrer}
            onCopy={() => setCopied(true)}
            className={classNames(
              "h-8 w-8 rounded-full cursor-pointer hover:scale-110 transition-all flex items-center justify-center",
              copied ? "bg-green-100" : "bg-gray-200"
            )}
          >
            <span>
              {copied ? (
                <CheckIcon
                  className="-ml-0.5 h-5 w-5 text-green-600"
                  aria-hidden="true"
                />
              ) : (
                <LinkIcon className="h-5 w-5 text-gray-500" />
              )}
            </span>
          </CopyToClipboard>
        )}
      </div>
    </div>
  );
}
